import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'semantic-ui-css/components/button.css';
import 'semantic-ui-css/components/icon.css';
import 'semantic-ui-css/components/label.css';
import AdminPage from './admin/admin.component';
import AdminChangePasswordComponent from './admin/components/authentication/change.password';
import AdminForgotPasswordComponent from './admin/components/authentication/forgot.password';
import AdminLoginComponent from './admin/components/authentication/login';
import BarcodePage from './admin/components/barcode/barcode-page';
import PriceSignPage from './admin/components/barcode/price-sign-page';
import AdminDashboardComponent from './admin/components/dashboard/dashboard.component';
import DayOffComponent from './admin/components/delivery/dayoff.component';
import DeliveryZonesComponent from './admin/components/delivery/delivery-zones.component';
import BannerForm from './admin/components/forms/banner.form';
import BrandForm from './admin/components/forms/brand.form';
import CategoryForm from './admin/components/forms/category.form';
import ClientForm from './admin/components/forms/client.form';
import CompanyForm from './admin/components/forms/company.form';
import ContentForm from './admin/components/forms/content.form';
import ProductForm from './admin/components/forms/product.form';
import ProviderForm from './admin/components/forms/provider.form';
import ProviderUserForm from './admin/components/forms/provider.user.form';
import SettingsForm from './admin/components/forms/settings.form';
import AdminLayout from './admin/components/layout/admin.layout';
import BannerList from './admin/components/list/banner.list';
import BrandList from './admin/components/list/brand.list';
import CategoryList from './admin/components/list/category.list';
import ClientList from './admin/components/list/client.list';
import CompanyList from './admin/components/list/company.list';
import ContentList from './admin/components/list/content.list';
import AdminProductList from './admin/components/list/product.list';
import ProviderList from './admin/components/list/provider.list';
import ProviderUserList from './admin/components/list/provider.user.list';
import SettingsList from './admin/components/list/settings.list';
import OrderComponent from './admin/components/order/order.component';
import ReportDeliveries from './admin/components/reports/delivery.report';
import ReportOrders from './admin/components/reports/order.report';
import ReportPapaDeliveries from './admin/components/reports/papa.delivery.report';
import ReportOrdersBi from './admin/components/reports/orders.bi.report';
import ReportPayments from './admin/components/reports/payment.report';
import AdminShelfComponent from './admin/components/shelf/shelf.admin';
import AdminWarehouseComponent from './admin/components/warehouse/warehouse.admin';
import AdminWarehouseAddComponent from './admin/components/warehouse/warehouse.admin.add';
import AdminWarehouseMinusPageComponent from './admin/components/warehouse/warehouse.admin.minus.page';
import AdminWarehouseActionsComponent from './admin/components/warehouse/warehouse.admin.actions';
import AdminWarehouseImportsPageComponent from './admin/components/warehouse/warehouse.admin.imports.page';
import AdminWarehouseImportHistoryPageComponent from './admin/components/warehouse/warehouse.admin.import.history.page';
import AdminWarehouseImportExpirePageComponent from './admin/components/warehouse/warehouse.admin.import.expire.page';
import AdminWarehouseCountComponent from './admin/components/warehouse/warehouse.admin.count';
import ReturnSearchPage from './admin/components/return/return.search.page';
import ReturnConfirmPage from './admin/components/return/return.confirm.page';
import ReturnHistoryPage from './admin/components/return/return.history.page';
import DeliveryCostHistoryPage from './admin/components/product/delivery-cost-history-page';
import ClubPriceHistoryPage from './admin/components/product/club-price-history-page';
import StorageCostHistoryPage from './admin/components/product/storage-cost-history-page';
import AboutUs from './components/aboutUs/aboutUs';
import ClientChangePasswordComponent from './components/authentication/change.password';
import ClientComponent from './components/authentication/client.component';
import ClientGuard from './components/authentication/client.guard';
import ClientForgotPasswordComponent from './components/authentication/forgot.password';
import ClientLoginComponent from './components/authentication/login';
import ClientSignupComponent from './components/authentication/signup';
import BrandPage from './components/brand-page/brand-page';
import BrandsPage from './components/brands/brands';
import CatalogPage from './components/catalog/catalog';
import CategoryPage from './components/category-page/category-page';
import DeliveryPage from './components/checkout/delivery';
import ClientOrderComponent from './components/client-order/client.order.component';
import ConfirmedOrderPage from './components/client-order/client.order.confirmed';
import ClientAccountPage from './components/client/account';
import ChangePassword from './components/client/changePassword';
import ClientOrdersPage from './components/client/client.orders';
import OrderReceiptPrintComponent from './components/client/order-receipt-print.component';
import CompanyOrdersPage from './components/client/company.orders';
import CompanyRoleActionPage from './components/client/company.role.action';
import CompanyUsersPage from './components/client/company.users';
import NewEmployee from './components/client/new-employee';
import SavedProductsPage from './components/client/saved-products';
import ContactPage from './components/contact/contact';
import Home from './components/home/home';
import NoContent from './components/no-content/no-content';
import PaymentPage from './components/payment/payment.component';
import ProductPage from './components/product-page/product-page';
import SearchPage from './components/search-page/search-page';
import ShopComponent from './components/shop/shop.component';
import StorePage from './components/store/store';
import StoreClientCompany from './components/store/store-client-company';
import Terms from './components/terms/terms';
import FooterLayout from './layouts/footer/footer';
import MainLayout from './layouts/main/layout';
import ProviderAccountPage from './provider/components/account';
import ProviderChangePasswordComponent from './provider/components/authentication/change.password';
import ProviderForgotPasswordComponent from './provider/components/authentication/forgot.password';
import ProviderLoginComponent from './provider/components/authentication/login';
import ProviderDashboard from './provider/components/dashboard/dashboard.component';
import ProviderProductsComponent from './provider/components/products';
import ProviderProductForm from './provider/components/provider.product.form';
import Shelf from './provider/components/shelf/shelf';
import WarehouseComponent from './provider/components/warehouse';
import WarehouseActionsComponent from './provider/components/warehouse.actions';
import ProviderLayout from './provider/layout/provider.layout';
import ProviderComponent from './provider/provider.component';
import './style/global.scss';
import './style/semantic-ui-overrides.scss';
import './style/icomoon/style.css';

// const dotenv = require('dotenv');
// dotenv.config();

class App extends React.Component {

  render() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Router>
        <div className="App">
          <Helmet>
              <meta charSet="utf-8" />
              <title>{process.env.REACT_APP_LOGO_NAME1} {process.env.REACT_APP_LOGO_NAME2}</title>
              <meta name="description" content={process.env.REACT_APP_DESCRIPTION}/>
              <meta name="og:title" content={process.env.REACT_APP_LOGO_NAME1 + ' ' + process.env.REACT_APP_LOGO_NAME2}/>
              <meta name="og:description" content={process.env.REACT_APP_DESCRIPTION}/>
              <meta property="og:type" content="website"/>
          </Helmet>
          <div className="app-container">
            <Switch>
              {/* admin routes */}
              <Route path='/mongol'>
                <AdminPage>
                  <AdminLayout>
                    <Route path="/mongol" exact={true} component={AdminDashboardComponent}/>
                    <Route path="/mongol/dashboard" exact={true} component={AdminDashboardComponent}/>
                    <Route path="/mongol/categorys" exact={true} component={CategoryList}/>
                    <Route path="/mongol/categories" exact={true} component={CategoryList}/>
                    <Route path="/mongol/categories/new" exact={true} component={CategoryForm}/>
                    <Route path="/mongol/category/:id" exact={true} component={CategoryForm}/>
                    <Route path="/mongol/brands" exact={true} component={BrandList}/>
                    <Route path="/mongol/brands/new" exact={true} component={BrandForm}/>
                    <Route path="/mongol/brand/:id" exact={true} component={BrandForm}/>
                    <Route path="/mongol/contents" exact={true} component={ContentList}/>
                    <Route path="/mongol/contents/new" exact={true} component={ContentForm}/>
                    <Route path="/mongol/content/:id" exact={true} component={ContentForm}/>
                    <Route path="/mongol/banners" exact={true} component={BannerList}/>
                    <Route path="/mongol/banners/new" exact={true} component={BannerForm}/>
                    <Route path="/mongol/banner/:id" exact={true} component={BannerForm}/>
                    <Route path="/mongol/providers/" exact={true} component={ProviderList}/>
                    <Route path="/mongol/providers/new" exact={true} component={ProviderForm}/>
                    <Route path="/mongol/provider/:id" exact={true} component={ProviderForm}/>
                    <Route path="/mongol/products/" exact={true} component={AdminProductList}/>
                    <Route path="/mongol/products/new" exact={true} component={ProductForm}/>
                    <Route path="/mongol/product/:id" exact={true} component={ProductForm}/>
                    <Route path="/mongol/clients" exact={true} component={ClientList}/>
                    <Route path="/mongol/client/:id" exact={true} component={ClientForm}/>
                    <Route path="/mongol/companys" exact={true} component={ClientList}/>
                    <Route path="/mongol/companies" exact={true} component={CompanyList}/>
                    <Route path="/mongol/companies/new" exact={true} component={CompanyForm}/>
                    <Route path="/mongol/company/:id" exact={true} component={CompanyForm}/>
                    <Route path="/mongol/provider-users" exact={true} component={ProviderUserList}/>
                    <Route path="/mongol/provider-user/:id" exact={true} component={ProviderUserForm}/>
                    <Route path="/mongol/settings" exact={true} component={SettingsList}/>
                    <Route path="/mongol/settings/:id" exact={true} component={SettingsForm}/>
                    <Route path="/mongol/report/orders" exact={true} component={ReportOrders}/>
                    <Route path='/mongol/report/order/:orderId' exact={true} component={OrderComponent}/>
                    <Route path="/mongol/report/delivery" exact={true} component={ReportDeliveries}/>
                    <Route path="/mongol/report/papa-deliveries" exact={true} component={ReportPapaDeliveries}/>
                    <Route path="/mongol/report/payments" exact={true} component={ReportPayments}/>
                    <Route path="/mongol/dayoff" exact={true} component={DayOffComponent}/>
                    <Route path="/mongol/delivery-zones" exact={true} component={DeliveryZonesComponent}/>
                    <Route path="/mongol/shelf" exact={true} component={AdminShelfComponent}/>
                    <Route path="/mongol/warehouse/:id" exact={true} component={AdminWarehouseComponent}/>
                    <Route path="/mongol/warehouse/:id/count" exact={true} component={AdminWarehouseCountComponent}/>
                    <Route path="/mongol/warehouse/:id/add" exact={true} component={AdminWarehouseAddComponent}/>
                    <Route path="/mongol/warehouse/:id/minus" exact={true} component={AdminWarehouseMinusPageComponent}/>
                    <Route path="/mongol/return" exact={true} component={ReturnSearchPage}/>
                    <Route path="/mongol/return/confirm" exact={true} component={ReturnConfirmPage}/>
                    <Route path="/mongol/return/history" exact={true} component={ReturnHistoryPage}/>
                    <Route path="/mongol/warehouse-actions/:id" exact={true} component={AdminWarehouseActionsComponent}/>
                    <Route path="/mongol/warehouse/:id/imports" exact={true} component={AdminWarehouseImportsPageComponent}/>
                    <Route path="/mongol/warehouse/:id/import/:importId/history" exact={true} component={AdminWarehouseImportHistoryPageComponent}/>
                    <Route path="/mongol/warehouse-import-expire-dates" exact={true} component={AdminWarehouseImportExpirePageComponent}/>
                    <Route path="/mongol/delivery-cost-history/:id" exact={true} component={DeliveryCostHistoryPage}/>
                    <Route path="/mongol/club-price-history/:id" exact={true} component={ClubPriceHistoryPage}/>
                    <Route path="/mongol/storage-cost-history/:id" exact={true} component={StorageCostHistoryPage}/>
                    <Route path="/mongol/barcode" exact={true} component={BarcodePage}/>
                    <Route path="/mongol/price-sign" exact={true} component={PriceSignPage}/>
                    <Route path="/mongol/report/ordersbi" exact={true} component={ReportOrdersBi}/>
                  </AdminLayout>
                </AdminPage>
              </Route>
              <Route exact path="/mongol-login" component={AdminLoginComponent}/>
              <Route exact path="/mongol-forgot-password" component={AdminForgotPasswordComponent}/>
              <Route exact path="/mongol-change-password/:forgotKey" component={AdminChangePasswordComponent}/>
              <Route exact path="/company-role/:action/:hash" component={CompanyRoleActionPage}/>
              {/* provider routes */}
              <Route exact path="/provider-login" component={ProviderLoginComponent}/>
              <Route path='/provider-forgot-password' component={ProviderForgotPasswordComponent}/>
              <Route path='/provider-change-password/:forgotKey' exact={true} component={ProviderChangePasswordComponent}/>
              <Route path="/provider">
                <ProviderComponent>
                  <ProviderLayout>
                    <Route path="/provider" exact={true} component={ProviderDashboard}/>
                    <Route path="/provider/account" exact={true} component={ProviderAccountPage}/>
                    <Route path="/provider/warehouse/:id" exact={true} component={WarehouseComponent}/>
                    <Route path="/provider/warehouse-actions/:id" exact={true} component={WarehouseActionsComponent}/>
                    <Route path="/provider/warehouse" exact={true} component={ProviderProductsComponent}/>
                    <Route path="/provider/products" exact={true} component={ProviderProductsComponent}/>
                    <Route path="/provider/products/new" exact={true} component={ProviderProductForm}/>
                    <Route path="/provider/product/:id" exact={true} component={ProviderProductForm}/>
                    <Route path="/provider/barcode" exact={true} component={BarcodePage}/>
                    <Route path="/provider/price-sign" exact={true} component={PriceSignPage}/>
                    <Route path="/provider/shelf" exact={true} component={Shelf}/>
                  </ProviderLayout>
                </ProviderComponent>
              </Route>
              {/* below routes have layout */}
              <Route path='/'>
                <ShopComponent>
                  <MainLayout></MainLayout>
              
                  {/* public routes */}
                  <ClientComponent>
                    <Route exact path='/' component={Home}/>
                    <Route exact path='/category/:slug' component={CategoryPage}/>
                    <Route exact path='/category/:parentSlug/:slug' component={CategoryPage}/>
                    <Route exact path='/brands' component={BrandsPage}/>
                    <Route exact path='/brand/:slug' component={BrandPage}/>
                    <Route exact path='/product/:slug' component={ProductPage}/>
                    <Route path='/search' component={SearchPage}/>
                    <Route path='/store/client-company' exact component={StoreClientCompany}/>
                    <Route path='/store' exact component={StorePage}/>
                    <Route path='/catalog' component={CatalogPage}/>
                    <Route path='/sale' component={SearchPage}/>
                    <Route path='/login' component={ClientLoginComponent}/>
                    <Route path='/signup' component={ClientSignupComponent}/>
                    <Route path='/forgot-password' component={ClientForgotPasswordComponent}/>
                    <Route path='/change-password/:forgotKey' exact={true} component={ClientChangePasswordComponent}/>
                    {/* client routes */}
                    <Route path="/client">
                      <ClientGuard>
                        <Route path='/client/checkout' exact={true} component={DeliveryPage}/>
                        <Route path='/client/payment/:token' exact={true} component={PaymentPage}/>
                        <Route path='/client/order/success/:token' exact={true} component={ConfirmedOrderPage}/>
                        <Route path='/client/order/:token' exact={true} component={ClientOrderComponent}/>
                        <Route path='/client/order-receipt/:token' exact={true} component={OrderReceiptPrintComponent}/>
                        <Route path='/client/orders' exact={true} component={ClientOrdersPage}/>
                        <Route path='/client/saved-products' exact={true} component={SavedProductsPage}/>
                        {/* client account */}
                        <Route path='/client/account' exact={true} component={ClientAccountPage}/>
                        <Route path='/client/change-password' exact={true} component={ChangePassword}/>
                        <Route path='/client/company/new-employee' exact={true} component={NewEmployee}/>
                        <Route path='/client/company/users' exact={true} component={CompanyUsersPage}/>
                        <Route path='/client/company/orders' exact={true} component={CompanyOrdersPage}/>
                        <Route path='/client/company/child-orders' exact={true} component={CompanyOrdersPage}/>
                      </ClientGuard>
                    </Route>
                  </ClientComponent>
                  {/* default routes */}
                  <Route exact path='/terms' component={Terms}/>
                  <Route exact path='/contact' component={ContactPage}/>
                  <Route exact path='/about-us' component={AboutUs}/>
                  <Route path='/no-content' component={NoContent}/>
                  <FooterLayout></FooterLayout>
                </ShopComponent>
              </Route>
              <Redirect to="/no-content"/>
            </Switch>
          </div>
        </div>
      </Router>
    </Suspense>
  );
  }
}

export default App;